import type { RootState } from "@src/store/rootState";
export function getHighlightMod(state: RootState) {
  const { highlightModId, mods } = state.experienceBuilder;
  return highlightModId ? mods.find((m) => m.id === highlightModId) : undefined;
}
